import moment from 'moment'

import { SHORTEN_TIME_FLAG } from 'constants/Booking'

import { berthApiClient } from '../berthApiClient'

import { updateRepeatStatusEndpoint } from './endpoint'
import type {
  UpdateRepeatStatusParams,
  UpdateRepeatStatusRequest,
  UpdateRepeatStatusResponse,
} from './type'

const API_DAY_FORMAT = 'YYYYMMDD'
const STANDARD_DAY_FORMAT = 'YYYY-MM-DD'

export const updateRepeatStatus = async (
  params: UpdateRepeatStatusParams
): Promise<UpdateRepeatStatusResponse> => {
  const body: UpdateRepeatStatusRequest = {
    repeat_id: params.repeatId,
    booking_id: params.bookingId,
    tenant_id: params.tenantId,
    start_datetime: `${moment(params.startDate, API_DAY_FORMAT).format(STANDARD_DAY_FORMAT)} ${params.startTime}`,
    end_datetime: `${moment(params.endDate, API_DAY_FORMAT).format(STANDARD_DAY_FORMAT)} ${params.endTime}`,
    status: params.status,
    is_tablet: false,
    shorten_time_flag: params.shortenTimeFlag ?? SHORTEN_TIME_FLAG.ON,
    blacklist_id: params.blacklistId,
  }
  const res = await berthApiClient.patch<UpdateRepeatStatusResponse>(
    updateRepeatStatusEndpoint,
    body
  )
  return res.data
}
